/* AlkoGames: shared product form, sticky add button and cart consent validation. */
if (!customElements.get('ag-sticky-cart')) {
  customElements.define('ag-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.product = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
      if (!this.product) return;
      this.sync = () => {
        this.form = this.product.querySelector('product-form form');
        const submit = this.form?.querySelector('.product-form__submit');
        this.button.disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        if (submit) this.button.textContent = submit.querySelector('span')?.textContent.trim() || '';
        const buyNow = this.form?.querySelector('[data-ag-buy-now]');
        if (buyNow && buyNow.disabled !== this.button.disabled) buyNow.disabled = this.button.disabled;
        if (this.anchor !== submit) {
          this.anchor = submit;
          this.intersection?.disconnect();
          if (submit) this.intersection?.observe(submit);
          this.updateVisibility();
        }
      };
      this.updateVisibility = () => {
        const visible = !!this.anchor && this.anchor.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-on', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
      };
      if ('IntersectionObserver' in window) this.intersection = new IntersectionObserver(this.updateVisibility);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.product, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.onClick = () => {
        this.sync();
        if (this.button.disabled || !this.form) return;
        this.form.requestSubmit(this.anchor);
      };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      window.addEventListener('resize', this.updateVisibility);
      this.sync();
    }
    disconnectedCallback() {
      this.intersection?.disconnect();
      this.mutations?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.updateVisibility);
      window.removeEventListener('resize', this.updateVisibility);
    }
  });
}

(() => {
  function consentPanel(form) {
    return [...document.querySelectorAll('[data-ag-consents]')].find(panel => panel.dataset.formId === form.id);
  }
  function validate(form) {
    const panel = consentPanel(form);
    if (!panel) return false;
    const missing = [...panel.querySelectorAll('[data-ag-consent]')].filter(box => !box.checked);
    panel.querySelectorAll('[data-ag-consent]').forEach(box => {
      box.closest('.ag-check').classList.toggle('ag-err', !box.checked);
      box.setAttribute('aria-invalid', String(!box.checked));
    });
    panel.querySelector('[data-ag-consent-error]').textContent = missing.length ? panel.dataset.error : '';
    if (missing.length) missing[0].focus();
    return !missing.length;
  }
  document.addEventListener('click', event => {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkout) return;
    const form = checkout.form;
    if (!form || !validate(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form || !consentPanel(form)) window.location.assign(window.routes.cart_url);
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    const isCheckout = event.submitter?.name === 'checkout';
    const implicitCheckout = !event.submitter && form.querySelector('[name="checkout"]');
    if ((isCheckout || implicitCheckout) && !validate(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!consentPanel(form)) window.location.assign(window.routes.cart_url);
    }
  }, true);
  document.addEventListener('change', event => {
    const box = event.target.closest('[data-ag-consent]');
    if (!box) return;
    box.closest('.ag-check').classList.remove('ag-err');
    box.removeAttribute('aria-invalid');
    const panel = box.closest('[data-ag-consents]');
    if ([...panel.querySelectorAll('[data-ag-consent]')].every(input => input.checked)) {
      panel.querySelector('[data-ag-consent-error]').textContent = '';
    }
  });
})();

if (!customElements.get('ag-cart')) {
  customElements.define('ag-cart', class extends HTMLElement {
    connectedCallback() {
      this.busy = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-ag-qty], [data-ag-remove]');
        if (!button) return;
        event.preventDefault();
        const row = button.closest('[data-ag-line]');
        const input = row.querySelector('[name="updates[]"]');
        const quantity = button.hasAttribute('data-ag-remove') ? 0 : Math.max(Number(input.min), Number(input.value) + Number(button.dataset.agQty) * Number(input.step));
        if (input.max && quantity > Number(input.max)) return;
        this.change(row, quantity);
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[name="updates[]"]')) return;
        if (!event.target.reportValidity()) return;
        this.change(event.target.closest('[data-ag-line]'), Number(event.target.value));
      });
      this.addEventListener('submit', event => {
        if (this.busy) event.preventDefault();
      });
    }
    async change(row, quantity) {
      if (this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const controls = [...this.querySelectorAll('button, input')].filter(control => !control.disabled);
      controls.forEach(control => control.disabled = true);
      const error = this.querySelector('[data-ag-cart-error]');
      error.textContent = '';
      try {
        const response = await fetch(`${window.routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: row.dataset.agLine, quantity })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || window.cartStrings.error);
        window.location.reload();
      } catch (err) {
        error.textContent = err.message || window.cartStrings.error;
        row.querySelector('[name="updates[]"]').value = row.dataset.quantity;
        controls.forEach(control => control.disabled = false);
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
